import Api from './api';

const favoriteSearchesListRequest = () => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().get('/api/searches', {
        headers: { Authorization: 'Bearer ' + access_token } ,
    })
}

const createFavoriteSearchRequest = (data) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().post('/api/searches/', data, { headers: { Authorization: 'Bearer ' + access_token } })
}

const deleteFavoriteSearchRequest = (id) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().delete('/api/search/' + id, { headers:
        {
            Authorization: 'Bearer ' + access_token,
            'Content-Type': 'application/x-www-form-urlencoded'
        }

    })
}


export default { favoriteSearchesListRequest, createFavoriteSearchRequest, deleteFavoriteSearchRequest }



// WEBPACK FOOTER //
// ./src/api/apiFavoriteSearches.js